import { useEffect } from 'react'
import { Icon, ThemeProvider } from 'ui'
import classes from '~/styles/error-boundary.module.scss'
import { navigatorError } from '~/utils/navigatorError'
import { printError } from '~/utils/printError'

import {
  Links,
  Meta,
  Scripts,
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from '@remix-run/react'

import { useRetryOnError } from '../../hooks/useRetryOnError'
import { Document } from '../RootComponents/Document'
import Layout from '../RootComponents/Layout'
import { DefaultErrorTemplate } from './DefaultError'
import { DevelopmentEnvComponent } from './DevelopmentEnvComponent'
import { ERROR_TEXT } from './constants'
import useHandleError from './useHandleError'

export function ErrorBoundary() {
  /* eslint-disable */
  const error = useRouteError()
  const navigate = useNavigate()

  console.info('<=====E====>', JSON.stringify(error))
  printError(error, 'ERRORBOUNDARY')
  const showDefaultErrBoundary = useHandleError(error)
  useRetryOnError(error)

  useEffect(() => {
    navigatorError()
  }, [])

  /*  NOTE: 
  1. Messaging looks odd.
      'Seems like something went wrong'
      'technical difficulties' 
  2. We should not be throwing errors if none the case matches. 
  */
  // let template
  if (isRouteErrorResponse(error)) {
    // if (CLIENT_SIDE_ERROR_CODES.includes(error.status)) {
    //   const messageLine =
    //     error.status == 500 ? 'Seems like something went wrong' : "We're having some"
    //   template = (
    //     <DefaultError
    //       messageLine1={messageLine}
    //       messageLine2="technical difficulties."
    //       buttonText="GO TO MPOWER PORTAL"
    //       messageDetails="Check back with us later while we figure out what went wrong."
    //       redirectURL="https://www.mpowerfinancing.com/"
    //     />
    //   )
    // } else {
    //   throw new Error(error.data || error.statusText)
    // }

    return (
      <Document title={`${error.status} ${error.statusText}`}>
        <Layout showHeader={false} showUser={false}>
          <DefaultErrorTemplate error={error} />
          {/* {template} */}
        </Layout>
      </Document>
    )
  }

  //Note: Shifting this logic as it is, but not sure what this is doing.
  const refreshPage = () => {
    const pageName = location?.pathname.split('/')[1]
    if (pageName === 'id-verification') {
      navigate('/id-verification/academic-period', { replace: false })
    } else {
      navigate(pageName, { replace: false })
    }
    location?.reload()
  }

  const reloadPage = () => {
    location?.reload()
  }

  let errorMessage = error instanceof Error ? error?.message : 'Unknown error'
  const apiError = errorMessage === 'API ERROR'
  const ERROR_CONTENT = apiError ? ERROR_TEXT.GENERIC : ERROR_TEXT.SOMETHING_WENT_WRONG
  const handleClick = apiError ? reloadPage : refreshPage

  return (
    <html>
      <head>
        <Meta />
        <Links />
      </head>
      <body>
        {showDefaultErrBoundary ? (
          <ThemeProvider>
            <div className={classes.themeWrapper}>
              <div className={classes.bgImageWrapper}>
                <Icon name="welcomeWave" />
              </div>
              <div className={classes.contentWrapper}>
                <img src={'/images/logo.jpeg'} className={classes.errorContent} />
                <>
                  <h1 className={classes.errorHeading}>
                    {ERROR_CONTENT.HEADING}
                    <br></br>
                    {ERROR_CONTENT.SUB_HEADING}
                  </h1>
                  <button onClick={handleClick} className={classes.buttonStyle}>
                    {ERROR_CONTENT.BUTTON_TEXT}
                  </button>
                </>
                <DevelopmentEnvComponent error={error} />
              </div>
            </div>
          </ThemeProvider>
        ) : (
          <></>
        )}
        <Scripts />
      </body>
    </html>
  )
}
